<script setup lang="ts">
  import i18n from '@/plugins/i18n';

  interface ProductDescriptionProps {
    product: {
      description: string;
      questionsAnswers: Array<{
        id: number;
        answer: string;
        question: string;
      }>;
    };
  }

  const props = defineProps<ProductDescriptionProps>();
</script>

<template>
  <div>
    <h3 class="tw-mb-2">{{ i18n.t('brand_menu.productDescription') }}</h3>
    <p v-html="props.product.description"></p>
    <div v-if="product.questionsAnswers.length">
      <h3 class="tw-mb-2">{{ `${i18n.t('common.product')} ${i18n.t('common.faq')}` }}</h3>
      <div v-for="item in product.questionsAnswers" :key="item.id">
        <h4 class="tw-mb-1">{{ item.question }}</h4>
        <p>{{ item.answer }}</p>
      </div>
    </div>
  </div>
</template>
